<template>
  <div>
    <div class="flex flex-col items-center justify-center text-center rounded-md gap-4 p-4" v-if="data === 'success'">
      <V3ImageComponent src="icons/tick.png" class="h-12 w-12 mb-2" />
      <h3 class="text-md font-semibold">Request raised successfully</h3>
      <p class="text-gray-600 text-[13px] md:text-sm text-left max-w-sm">
        Your request has been submitted.<br /> We'll contact you if needed, or you <br />can check your ticket for updates.
      </p>
      <div class="w-full max-w-sm px-3">
        <UButton 
          size="md" 
          label="GO TO HOME" 
          class="w-full"
          @click="navToHome"
        />
      </div>
    </div>

    <div class="flex flex-col items-center justify-center text-center rounded-md gap-4 p-4" v-if="data === 'failed'">
      <V3ImageComponent src="icons/sad.png" class="h-12 w-12 mb-2" />
      <h3 class="text-md font-semibold">Request Failed</h3>
      <div class="w-full max-w-sm px-3">
        <UButton 
          size="lg" 
          label="GO TO HOME" 
          class="w-full"
          @click="navToHome"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['data']);

const { gtag } = useGtag();
  const auth = useAuth();
    const isAuthenticated = auth && auth.access_token;
    const userData = isAuthenticated ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    } : {
      user_name: null,
      user_phone: null,
      user_email: null
    };

const navToHome = () => {
  gtag('event', 'cta_event', {
      action: 'click',
      cta_name: 'go to homepage',
      ...userData,
    });
    navigateTo({ path: '/'})
};
</script>
